module.exports = __webpack_public_path__ + "static/media/unlocked.b8920094.png";